import React from 'react'
import './footer.css'
import {
  FiTwitter,
  FiGithub,
  FiLinkedin,
  FiInstagram,
  FiFacebook,
} from 'react-icons/fi'
import { data } from './data'

const Footer = ({ currentPath, scrollToSection }) => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">Abhishek Honnapure</h1>
        <ul className="footer__list">
          {data.map((data) => (
            <li key={data.id}>
              <a
                href={data.path}
                className={`${
                  currentPath === data.path ? 'active-link' : ''
                } footer__link`}
                onClick={(e) => scrollToSection(data.path, data.id, e)}
              >
                {data.label}
              </a>
            </li>
          ))}
        </ul>
        <div className="footer__social">
          <a
            href="https://twitter.com/AbhishekHonnap4"
            className="home__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <FiTwitter />
          </a>
          <a
            href="https://github.com/its-abhishek"
            className="home__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <FiGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/abhishek-honnapure"
            className="home__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <FiLinkedin />
          </a>
          <a
            href="https://www.instagram.com/abhishek_honnapure/"
            className="home__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <FiInstagram />
          </a>
          <a
            href="https://www.facebook.com/abhi.honnapure"
            className="home__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <FiFacebook />
          </a>
        </div>
        <div className="footer__copy">
          <small>
            &copy; Abhishek Honnapure - 2024 . Source code under MIT License
          </small>
        </div>
      </div>
    </footer>
  )
}

export default Footer
